import { ref } from 'vue'
import { STUDIO_PLUS_PRODUCT_TYPE } from '@/constants/premiumProducts'

const startDate = ref(null)
const endDate = ref(null)

const productOptions = [
  { id: 0, label: 'campaign_subscription_status_all', value: 'all' },
  { id: 'plus', label: 'navigation_menu_business_studio_plus', value: STUDIO_PLUS_PRODUCT_TYPE.PLUS },
  { id: 'rate-connect', label: 'navigation_menu_rate_connect', value: 'RATE_CONNECT' },
]
const proProductOption = { id: 'pro', label: 'product.proPackage.name', value: STUDIO_PLUS_PRODUCT_TYPE.PRO }
const productTypeOptions = ref([...productOptions])
const selectedPropertyValues = ref([{ value: 'all', label: 'campaign_subscription_status_all', id: 0 }])
const selectedStatusValues = ref([{ value: 'all', label: 'campaign_subscription_status_all', id: 0 }])
const statusOptions = ref([
  { id: 0, label: 'campaign_subscription_status_all', value: 'all' },
  { id: 'payment-due', label: 'tbs_invoice_payment_due', value: 'PAYMENT_DUE' },
  { id: 'overdue', label: 'tbs_invoice_payment_overdue', value: 'OVERDUE' },
  { id: 'paid', label: 'tbs_invoice_payment_paid', value: 'PAID' },
])
const selectedProductValues = ref([{ id: 0, label: 'campaign_subscription_status_all', value: 'all' }])
const propertiesOptions = ref([])
const timeframeValue = ref({ id: 'last-6-months', label: 'last_6_months', value: '6' })
const isMobileFiltersOpen = ref(false)
const isFlyoutFiltersOpen = ref(false)
const selectedFiltersAmount = ref(0)

export function useInvoicesFilters() {
  const setStartDate = timeframe => {
    const d = new Date()
    const date = new Date(d.getFullYear(), d.getMonth() - timeframe.value, 1)
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    startDate.value = `${year}-${month}-${day}`
  }

  const setEndDate = () => {
    const today = new Date()

    const isFirstDayOfMonth = today.getDate() === 1

    let endDateObj
    if (isFirstDayOfMonth) {
      endDateObj = new Date(today.getFullYear(), today.getMonth(), 0)
    } else {
      endDateObj = today
    }

    const year = endDateObj.getFullYear()
    const month = String(endDateObj.getMonth() + 1).padStart(2, '0')
    const day = String(endDateObj.getDate()).padStart(2, '0')
    endDate.value = `${year}-${month}-${day}`
  }

  const openMobileFilters = () => {
    isMobileFiltersOpen.value = true
  }
  const closeMobileFilters = () => {
    isMobileFiltersOpen.value = false
  }

  const openFlyoutFilters = () => {
    isFlyoutFiltersOpen.value = true
  }
  const closeFlyoutFilters = () => {
    isFlyoutFiltersOpen.value = false
  }

  const resetFilters = () => {
    startDate.value = null
    endDate.value = null
    selectedPropertyValues.value = [{ value: 'all', label: 'campaign_subscription_status_all', id: 0 }]
    selectedStatusValues.value = [{ value: 'all', label: 'campaign_subscription_status_all', id: 0 }]
    selectedProductValues.value = [{ value: 'all', label: 'campaign_subscription_status_all', id: 0 }]
    timeframeValue.value = { id: 'last-6-months', label: 'last_6_months', value: '6' }
    selectedFiltersAmount.value = 0
  }

  return {
    setStartDate,
    setEndDate,
    startDate,
    endDate,
    selectedPropertyValues,
    selectedStatusValues,
    statusOptions,
    selectedProductValues,
    productOptions,
    proProductOption,
    productTypeOptions,
    propertiesOptions,
    timeframeValue,
    isMobileFiltersOpen,
    isFlyoutFiltersOpen,
    selectedFiltersAmount,
    openFlyoutFilters,
    closeFlyoutFilters,
    openMobileFilters,
    closeMobileFilters,
    resetFilters,
  }
}
